// Intro Section
export const textsInto: string[] = [
  ``,
  `Hi! I'm Jhaden. I'm in my third year studying Computer Science at Ontario Tech University.`,
];

// Contact section
export const textsContact: string[] = [
  `If you have any questions, drop me a line at:<br>jhadengoy@gmail.com`,
];

// About section
export const textsAbout: string[] = [
  `I'm passionate about AI engineering, especially building intelligent systems and agents that simplify complex workflows.`,

  ` I love creating immersive web experiences that stand out, leave a lasting impression, and push the boundaries of what's possible, helping shape the future of the web.`,

  `My primary languages are Python and JavaScript alongside various other frameworks and libraries.`,

  `I own three cats, I love snowboarding, bouldering, playing the electric guitar and fixing up old cars!`,
];
